/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Dev_BackendInputs */

const en_mobile_dev_backend = /** @type {(inputs: Mobile_Dev_BackendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Backend`)
};

const es_mobile_dev_backend = /** @type {(inputs: Mobile_Dev_BackendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Backend`)
};

/**
* | output |
* | --- |
* | "Backend" |
*
* @param {Mobile_Dev_BackendInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_dev_backend = /** @type {((inputs?: Mobile_Dev_BackendInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Dev_BackendInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_dev_backend(inputs)
	return en_mobile_dev_backend(inputs)
});